import { api } from '..';
import { FilterState } from '../../ui/filter-panel';
import { Preset } from '../../ui/filter-panel/types';

interface CreatePresetInput {
  name: string;
  filters: FilterState;
  table_name: string;
}

export const createPreset = async ({
  name,
  filters,
  table_name,
}: CreatePresetInput): Promise<Preset> => {
  const data = await api.post('/api/v1/general/user/preset/', {
    body: {
      name,
      filters,
      table_name,
    },
  });

  return data as Preset;
};
